<template>
  <div>
    <main-layout>
      <v-container>
        <v-layout wrap class="pt-4">
          <v-flex xs12 sm6>
            <h1>{{ $t('ads_management') }}</h1>
          </v-flex>
          <v-flex xs12 sm6 class="text-sm-right text-xs-right">
            <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
              <v-icon>search</v-icon>
              &nbsp;
              {{ $t('advanced search') }}&nbsp;
              <em v-if="!showAdvancedSearch" class="fas fa-angle-down" />
              <em v-else class="fas fa-angle-up" />
            </v-btn>
            <v-btn dark outline color="primary" :loading="exportLoading" @click="handleExportXlsx">
              <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
            </v-btn>
            <v-btn
              dark
              depressed
              color="primary"
              :loading="exportLoading"
              @click="handleAddAdsItem"
            >
              <em class="fas fa-plus" />&nbsp;{{ $t('add_ads_item') }}
            </v-btn>
          </v-flex>
          <v-flex>
            <div
              v-if="showAdvancedSearch"
              class="mb-4 py-2"
              style="border: 1px solid #eee; border-radius: 10px; position: relative"
            >
              <v-layout wrap class="form-control">
                <v-flex xs12 sm4 px-2>
                  <div class="caption">Ads ID</div>
                  <input v-model="filter.ad_id" type="text" placeholder="Ads ID" />
                </v-flex>
                <v-flex xs12 sm4 px-2>
                  <div class="caption">Type</div>
                  <multiselect
                    v-model="filter.type"
                    :options="assignTypeOptions"
                    label="label"
                    select-label
                    selected-label
                    track-by="value"
                  ></multiselect>
                </v-flex>
                <v-flex xs12 sm4 px-2>
                  <div class="caption">Assign To</div>
                  <input v-model="filter.assign_to" type="text" placeholder="Assign To" />
                </v-flex>
                <v-flex xs12 class="text-xs-right">
                  <v-btn outline color="grey" @click="handleClearSearch">{{
                    $t('Clear Search')
                  }}</v-btn>
                  <v-btn depressed color="primary" @click="handleSearch">
                    <em class="fas fa-search mr-1" />
                    {{ $t('Search') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
        <v-data-table
          hide-actions
          :headers="headers"
          :items="dataList"
          :pagination.sync="pagination"
          class="elevation-1 mt-3"
        >
          <template #items="props">
            <tr @click="handleEditAdsItem(props.item)">
              <td>{{ props.item.ad_id }}</td>
              <td>{{ props.item.type || '-' }}</td>
              <td>{{ props.item.assign_to || '-' }}</td>
              <td>{{ props.item.created_at | DateFormat('DD/MM/YYYY HH:mm') }}</td>
              <td class="text-no-wrap">
                <v-btn fab outline small color="primary" @click="handleEditAdsItem(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  fab
                  outline
                  small
                  color="primary"
                  @click.prevent.stop="handleDeleteAdsItem(props.item)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="mt-2">
          <v-pagination
            v-model="pageNumber"
            :total-visible="6"
            :length="pageLength"
            @input="handleChangePage"
          ></v-pagination>
        </div>
      </v-container>

      <AdsManageFormDialog
        v-model="selectedItem"
        :open="adsManageFormDialogOpen"
        :form-type="formType"
        @onClose="adsManageFormDialogOpen = false"
        @onSaveSuccess="handleSearch"
      />
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import * as XLSX from 'xlsx'
import Multiselect from 'vue-multiselect'
import { handleResponse, handleApiError } from '@/api/util'
import adsManagementApi from '@/api/ads-management'
import AdsManageFormDialog from './AdsManageFormDialog'

export default {
  components: {
    Multiselect,
    AdsManageFormDialog
  },
  data() {
    return {
      showAdvancedSearch: false,
      exportLoading: false,
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pageTemp: 1,
      pageNumber: 1,
      dataList: [],
      headers: [
        { text: 'Ads ID', value: 'ad_id', sortable: false },
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Assign To', value: 'assign_to', sortable: false },
        { text: 'Created At', value: 'created_at', sortable: false },
        { text: '', value: '', sortable: false }
      ],
      filter: {
        ad_id: '',
        type: '',
        assign_to: ''
      },
      assignTypeOptions: [
        { label: 'Group', value: 'group' },
        { label: 'Agent', value: 'agent' }
      ],
      isExport: false,

      formType: 'add',
      adsManageFormDialogOpen: false,
      selectedItem: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pageLength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.handleFetchAdsList()
  },
  methods: {
    async handleFetchAdsList() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getAdsManagement()

        if (response && response.status === 200) {
          vm.$store.commit('CLEAR_LOADING')
          vm.dataList = response.data.data
          vm.total = response.data.total || 0
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    async getAdsManagement() {
      const vm = this
      try {
        const limit = vm.isExport ? vm.total : vm.limit
        const offset = vm.isExport ? 0 : vm.offset

        const params = {
          page_id: vm.selectedBot.pageid,
          limit,
          offset
        }

        Object.entries(vm.filter).forEach(([key, value]) => {
          if (value && Object.keys(value).length > 0) {
            Object.assign(params, { [key]: value.value })
          }
          if (value && value.length) {
            Object.assign(params, { [key]: value.toLowerCase() })
          }
        })

        const response = await adsManagementApi.getAdsManagement({ params })

        handleResponse(response)

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        handleApiError(error)
        return null
      }
    },
    async handleExportXlsx() {
      const vm = this
      try {
        vm.isExport = true
        const response = await vm.getAdsManagement()
        const requestData = response.data.data
        vm.isExport = false

        if (requestData == null) return
        const requests = requestData.map((el) => {
          return {
            ad_id: el.ad_id,
            type: el.type || '',
            assign_to: el.assign_to,
            created_at: el.created_at ? dayjs(el.created_at).format('DD/MM/YYYY') : '-'
          }
        })

        const heading = [['Ads ID', 'Assign Type', 'Assign To', 'Created AT']]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `ads-management.xlsx`)
      } catch (error) {
        console.error(error)
      }
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pageTemp !== val) {
        vm.pageTemp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.handleFetchAdsList()
      }
    },
    handleSearch() {
      this.offset = 0
      this.handleFetchAdsList()
    },
    handleClearSearch() {
      this.filter = {
        ad_id: '',
        type: '',
        assign_to: ''
      }
      this.handleSearch()
    },
    handleAddAdsItem() {
      this.formType = 'add'
      this.adsManageFormDialogOpen = true
    },
    handleEditAdsItem(item) {
      this.formType = 'edit'
      this.selectedItem = item
      this.adsManageFormDialogOpen = true
    },
    async handleDeleteAdsItem(item) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          title: vm.$t('Do you want to delete this?'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        if (result.value) {
          vm.$store.dispatch('loading')

          const data = {
            id: item.id,
            page_id: vm.selectedBot.pageid,
            ad_id: item.ad_id
          }

          const response = await await adsManagementApi.deleteAdsManagement({ data })

          if (response && response.status == 204) {
            vm.$store.commit('CLEAR_LOADING')
            vm.$swal.fire({
              type: 'success',
              title: vm.$t('Success')
            })
            vm.handleSearch()
          }
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/AdsManagement/AdsManagement.vue